import { CUSTOMER_NEEDS, NEEDS_PRODUCT_TYPE_SLUG } from '@ahmdigital/constants';
import React from 'react';

import CalloutSection from '../../../../components/sections/callout-section';
import constants from '../../../../ahm-constants';
import curiousImage from './images/curious.svg';

const {
  URLS: {
    SALES: { PRODUCT_LISTING },
  },
} = constants;
const { PREGNANCY_COVER } = CUSTOMER_NEEDS;
const { EXTRAS } = NEEDS_PRODUCT_TYPE_SLUG;

const PregnancyCallout = () => (
  <CalloutSection
    title="Missed the 12-month hospital cover waiting period?"
    summary="You can still join extras cover to claim for things like pre & post-natal services including birthing
          courses. There may still be waiting periods, but most are less than 12 months."
    cta={{ title: 'Compare extras', to: `${PRODUCT_LISTING}/${PREGNANCY_COVER}/${EXTRAS}` }}
    image={{ alt: '', src: curiousImage.src }}
    withBorder
  />
);

export default PregnancyCallout;
